import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Index",
		component: () => import("../views/Index.vue")
	},
	{
		path: "/",
		name: "PCReDive",
		component: () => import("../views/Index.vue")
	},
	{
		path: "/Equipment",
		name: "Equipment",
		component: () => import("../views/Equipment.vue")
	},
	{
		path: "/Equipment/Detail/:id",
		name: "EquipmentDetail",
		component: () => import("../views/EquipmentDetail.vue")
	},
	{
		path: "/ExEquipment",
		name: "ExEquipment",
		component: () => import("../views/ExEquipment.vue")
	},
	{
		path: "/ExEquipment/Detail/:id",
		name: "ExEquipmentDetail",
		component: () => import("../views/ExEquipmentDetail.vue")
	},
	{
		path: "/About",
		name: "About",
		component: () => import("../views/About.vue")
	},
	{
		path: "/Gacha",
		name: "Gacha",
		component: () => import("../views/Gacha.vue")
	},
	{
		path: "/Map",
		name: "Map",
		component: () => import("../views/Map.vue")
	},
	{
		path: "/Map/Detail/:id",
		name: "MapDetail",
		component: () => import("../views/MapDetail.vue")
	},
	{
		path: "/Character",
		name: "Character",
		component: () => import("../views/Character.vue")
	},
	{
		path: "/Character/Detail/:id",
		name: "CharacterDetail",
		component: () => import("../views/CharacterDetail.vue")
	},
	{
		path: "/Armory",
		name: "Armory",
		component: () => import("../views/Armory.vue")
	},
	{
		path: "/Synchro",
		name: "Synchro",
		component: () => import("../views/Synchro.vue")
	},
	{
		path: "/BattleReport",
		name: "BattleReport",
		component: () => import("../views/BattleReport.vue")
	},
	{
		path: "/Stand",
		name: "Stand",
		component: () => import("../views/Stand.vue")
	},
	{
		path: "/PublicArenaReport",
		name: "PublicArenaReport",
		component: () => import("../views/PublicArenaReport.vue")
	},
	{
		path: "/Guild",
		name: "Guild",
		component: () => import("../views/Guild.vue")
	},
	{
		path: "/SkillCheck",
		name: "SkillCheck",
		component: () => import("../views/SkillCheck.vue")
	},
	{
		path: "/Compensate",
		name: "Compensate",
		component: () => import("../views/Compensate.vue")
	},
	{
		path: "/UnitStatus",
		name: "UnitStatus",
		component: () => import("../views/UnitStatus.vue")
	},
	{
		path: "/UniqueEquipment",
		name: "UniqueEquipment",
		component: () => import("../views/UniqueEquipment.vue")
	},
	{
		path: "/Login",
		name: "Login",
		component: () => import("../views/Login.vue")
	},
	{
		path: "/Register",
		name: "Register",
		component: () => import("../views/Register.vue")
	},
	{
		path: "/Resume",
		name: "Resume",
		component: () => import("../views/Resume.vue")
	},
	{
		path: "/Other/Stamina",
		name: "Stamina",
		component: () => import("../views/Other/Stamina.vue")
	},
	{
		path: "/Other/ArenaFindRank",
		name: "ArenaFindRank",
		component: () => import("../views/Other/ArenaFindRank.vue")
	},
	{
		path: "/Other/PieceOfMemory",
		name: "PieceOfMemory",
		component: () => import("../views/Other/PieceOfMemory.vue")
	},
	{
		path: "/Other",
		name: "Other",
		component: () => import("../views/Other.vue")
	},
	{
		path: "/Other/Exp",
		name: "Exp",
		component: () => import("../views/Other/Exp.vue")
	},
	{
		path: "/Other/Mana",
		name: "Mana",
		component: () => import("../views/Other/Mana.vue")
	},
	{
		path: "/Other/Megami",
		name: "Megami",
		component: () => import("../views/Other/Megami.vue")
	},
	{
		path: "/Other/Arena",
		name: "Arena",
		component: () => import("../views/Other/Arena.vue")
	},
	{
		path: "/Other/Clan",
		name: "Clan",
		component: () => import("../views/Other/Clan.vue")
	},
	{
		path: "/Other/GrandArena",
		name: "GrandArena",
		component: () => import("../views/Other/GrandArena.vue")
	},
	{
		path: "/Other/Dungeon",
		name: "Dungeon",
		component: () => import("../views/Other/Dungeon.vue")
	},
	{
		path: "/Other/StatusEffect",
		name: "StatusEffect",
		component: () => import("../views/Other/StatusEffect.vue")
	},
	{
		path: "/Other/UnitXp",
		name: "UnitXp",
		component: () => import("../views/Other/UnitXp.vue")
	},
	{
		path: "/Other/YukiXp",
		name: "YukiXp",
		component: () => import("../views/Other/YukiXp.vue")
	},
	{
		path: "/Other/Donors",
		name: "Donors",
		component: () => import("../views/Other/Donors.vue")
	},
	{
		path: "/Other/Ecpay",
		name: "Ecpay",
		component: () => import("../views/Other/Ecpay.vue")
	},
	{
		path: "/Other/EquipmentRequire",
		name: "EquipmentRequire",
		component: () => import("../views/Other/EquipmentRequire.vue")
	},
	{
		path: "/Other/MapExtraDrop",
		name: "MapExtraDrop",
		component: () => import("../views/Other/MapExtraDrop.vue")
	},
	{
		path: "/Other/PrivacyPolicy",
		name: "PrivacyPolicy",
		component: () => import("../views/Other/PrivacyPolicy.vue")
	},
	{
		path: "/Other/EquipmentReduce",
		name: "EquipmentReduce",
		component: () => import("../views/Other/EquipmentReduce.vue")
	},
	{
		path: "/Other/UnitStartList",
		name: "UnitStartList",
		component: () => import("../views/Other/UnitStartList.vue")
	},
	{
		path: "/Other/Birthday",
		name: "Birthday",
		component: () => import("../views/Other/Birthday.vue")
	},
	{
		path: "/Other/Whoami",
		name: "Whoami",
		component: () => import("../views/Other/Whoami.vue")
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

export default router;
